import { defineNuxtPlugin } from "#app";
import { useApi } from "../composables/api.mjs";
export default defineNuxtPlugin(async (nuxtApp) => {
  const moment = await import("moment");
  await import("moment/dist/locale/de");
  const locale = "de";
  const useMoment = moment.default;
  useMoment.locale(locale);
  nuxtApp.provide("axios", () => useApi());
  nuxtApp.provide("moment", useMoment);
  nuxtApp.provide("slugify", (string) => {
    const a = "\xE0\xE1\xE2\xE4\xE6\xE3\xE5\u0101\u0103\u0105\xE7\u0107\u010D\u0111\u010F\xE8\xE9\xEA\xEB\u0113\u0117\u0119\u011B\u011F\u01F5\u1E27\xEE\xEF\xED\u012B\u012F\xEC\u0142\u1E3F\xF1\u0144\u01F9\u0148\xF4\xF6\xF2\xF3\u0153\xF8\u014D\xF5\u0151\u1E55\u0155\u0159\xDF\u015B\u0161\u015F\u0219\u0165\u021B\xFB\xFC\xF9\xFA\u016B\u01D8\u016F\u0171\u0173\u1E83\u1E8D\xFF\xFD\u017E\u017A\u017C\xB7/_,:;";
    const b = "aaaaaaaaaacccddeeeeeeeegghiiiiiilmnpx nuxi cleanup [rootDir]nnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------";
    const p = new RegExp(a.split("").join("|"), "g");
    return string.toString().toLowerCase().replace(/\s+/g, "-").replace(/[\])}[{(]/g, "").replace(p, (c) => b.charAt(a.indexOf(c))).replace(/^-+/, "").replace(/-+$/, "");
  });
  nuxtApp.provide("formatTime", (time, format) => {
    const defaultFormat = format !== void 0 ? format : "DD.MM.YYYY";
    return useMoment(time).format(defaultFormat);
  });
  nuxtApp.provide("getDateTimeString", (object, dateFormat, timeFormat) => {
    const defaultDateFormat = dateFormat !== void 0 ? dateFormat : "DD.MM.YYYY";
    const defaultTimeFormat = timeFormat !== void 0 ? timeFormat : "HH:mm";
    const dateFrom = object.dateFrom ? useMoment(object.dateFrom).format(defaultDateFormat) : null;
    let dateTo = object.dateTo ? useMoment(object.dateTo).format(defaultDateFormat) : null;
    let timeFrom = object.timeFrom ? useMoment(object.timeFrom).format(defaultTimeFormat) : null;
    let timeTo = object.timeTo ? useMoment(object.timeTo).format(defaultTimeFormat) : null;
    timeFrom = timeFrom !== "00:00" ? timeFrom : null;
    timeTo = timeTo !== "00:00" && timeFrom !== timeTo ? timeTo : null;
    dateTo = dateTo !== dateFrom ? dateTo : null;
    if (dateFrom && dateTo && timeFrom && timeTo)
      return `${dateFrom} - ${dateTo}, ${timeFrom} Uhr - ${timeTo} Uhr`;
    if (dateFrom && dateTo && timeFrom)
      return `${dateFrom} - ${dateTo}, ${timeFrom} Uhr`;
    if (dateFrom && timeFrom)
      return `${dateFrom}, ${timeFrom} Uhr`;
    if (dateFrom && dateTo)
      return `${dateFrom} - ${dateTo}`;
    if (dateFrom)
      return `${dateFrom}`;
    if (timeFrom && timeTo)
      return `${timeFrom} Uhr - ${timeTo} Uhr`;
    if (timeFrom)
      return `${timeFrom} Uhr`;
    return null;
  });
});
